/**
 * キービジュアル動画分割機能の型定義
 */

/**
 * 進行状況のステップ状態
 */
export type ProgressStepStatus = 'pending' | 'active' | 'completed' | 'error';

/**
 * 進行状況のステップ
 */
export interface ProgressStep {
  name: string;
  status: ProgressStepStatus;
  percentage: number;
}

/**
 * アップロードされた画像データ
 */
export interface UploadedImage {
  file: File;
  base64: string;
  preview: string;
}

/**
 * 動画生成リクエスト
 */
export interface VideoGenerationRequest {
  image: string; // Base64形式の画像
  prompt: string; // 動画生成プロンプト
  splitCount: number; // 分割数
}

/**
 * 動画生成レスポンス
 */
export interface VideoGenerationResponse {
  success: boolean;
  data?: {
    jobId: string;
    videoUrl?: string;
    splitImages?: string[];
  };
  error?: string;
}

/**
 * 動画分割リクエスト
 */
export interface VideoSplitRequest {
  videoUrl: string;
  splitCount: number;
}

/**
 * 動画分割レスポンス
 */
export interface VideoSplitResponse {
  success: boolean;
  data?: {
    images: string[];
    totalFrames: number;
  };
  error?: string;
}

/**
 * Vision API分析レスポンス
 */
export interface VisionAnalysisResponse {
  success: boolean;
  data?: string;
  error?: string;
}

/**
 * 統合処理の結果
 */
export interface VisualSplitResult {
  success: boolean;
  images: string[];
  totalCount: number;
  videoUrl?: string; // 生成された動画のURL
  error?: string;
}

/**
 * 進行状況の通知データ
 */
export interface ProgressUpdate {
  currentStep: number;
  steps: ProgressStep[];
  isComplete: boolean;
  result?: VisualSplitResult;
  error?: string;
}

/**
 * エラータイプ
 */
export enum VisualSplitErrorType {
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  VISION_ANALYSIS_ERROR = 'VISION_ANALYSIS_ERROR',
  VIDEO_GENERATION_ERROR = 'VIDEO_GENERATION_ERROR',
  VIDEO_SPLIT_ERROR = 'VIDEO_SPLIT_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/**
 * カスタムエラー
 */
export interface VisualSplitError {
  type: VisualSplitErrorType;
  message: string;
  details?: any;
}